module.exports = __webpack_public_path__ + "media/images/controls-fac80c33f3605dff9d8e2688b3486163.svg";